module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shipping-form container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column half"
  }, [_c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:first_name",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "first_name"
    }],
    attrs: {
      "label": "First name",
      "id": "first_name",
      "name": "first_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column half"
  }, [_c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:last_name",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "last_name"
    }],
    attrs: {
      "label": "Last name",
      "id": "last_name",
      "name": "last_name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:email",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "email"
    }],
    attrs: {
      "label": "Email",
      "type": "email",
      "id": "email",
      "name": "email"
    }
  }), _vm._v(" "), _c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:phone",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "phone"
    }],
    attrs: {
      "label": "Phone (optional)",
      "type": "tel",
      "id": "phone",
      "name": "phone",
      "mask": "(###) ###-####",
      "save-mask": false
    }
  }), _vm._v(" "), _c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:address1",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "address1"
    }],
    attrs: {
      "label": "Street Address",
      "id": "address1",
      "name": "address1"
    }
  }), _vm._v(" "), _c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:address2",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "address2"
    }],
    attrs: {
      "label": "Address Line 2",
      "id": "address2",
      "name": "address2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:city",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "city"
    }],
    attrs: {
      "label": "City",
      "id": "city",
      "name": "city"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('form-select', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:state",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "state"
    }],
    attrs: {
      "label": "State",
      "id": "state",
      "name": "state",
      "options": _vm.states
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('form-text', {
    directives: [{
      name: "input-sync",
      rawName: "v-input-sync:zip",
      value: (_vm.shipping),
      expression: "shipping",
      arg: "zip"
    }],
    attrs: {
      "label": "Zip",
      "id": "zip",
      "name": "zip",
      "mask": "#####-####"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button btn-sm btn-success",
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("\n            Save\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39d63b71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShippingForm.vue
// module id = 215
// module chunks = 1